import { useState } from "react";

import clsx from "clsx";

import { type BreakdownGroupDescriptor } from "@north-beam/nb-common";
import {
  PrimaryButton,
  SecondaryButton,
  TertiaryButton,
} from "@shared/buttons";
import { Checkbox } from "@shared/checkbox";
import { Modal } from "@shared/modal";
import Spinner from "@shared/spinner";

interface Props {
  isOpen: boolean;
  breakdownGroup: BreakdownGroupDescriptor;
  switching: boolean;
  duplicating: boolean;
  onClose: () => void;
  onConfirm: () => void;
  onDuplicate: () => void;
}

export const SwitchEditorComfirmationModal = ({
  isOpen,
  breakdownGroup,
  switching,
  duplicating,
  onClose,
  onConfirm,
  onDuplicate,
}: Props) => {
  const [isAcknowledged, setIsAcknowledged] = useState(false);

  return (
    <Modal
      size="xl"
      isOpen={isOpen}
      titleContent={
        <h3
          className={clsx(
            "heading mx-0 mb-0 mt-0 font-bold text-[1.5rem] max-w-[500px]",
            "leading-8",
          )}
        >
          Switch “{breakdownGroup.name}” to the advanced editor? This action
          cannot be undone.
        </h3>
      }
      onClose={onClose}
    >
      <div className="mt-3 mb-12">
        <label className="flex items-center gap-2">
          <Checkbox value={isAcknowledged} onChange={setIsAcknowledged} /> I
          acknowledge this breakdown will be updated for all users on the
          account
        </label>
      </div>
      <div className="flex items-center justify-end gap-2">
        <TertiaryButton
          disabled={switching || duplicating}
          className="ml-2 font-bold"
          onClick={onClose}
        >
          CANCEL
        </TertiaryButton>
        <SecondaryButton
          disabled={switching || duplicating}
          className="font-bold flex items-center gap-2"
          onClick={() => onDuplicate()}
        >
          {duplicating && <Spinner colorClassname="text-white-400" />}
          INSTEAD, DUPLICATE AS ADVANCED
        </SecondaryButton>
        <PrimaryButton
          disabled={!isAcknowledged || switching || duplicating}
          className={clsx("font-bold flex items-center gap-2", {
            "bg-mars hover:bg-mars+2":
              isAcknowledged && !(switching || duplicating),
          })}
          onClick={onConfirm}
        >
          {switching && <Spinner colorClassname="text-white-400" />}
          YES, CONTINUE
        </PrimaryButton>
      </div>
    </Modal>
  );
};

export const SwitchCreatorComfirmationModal = ({
  isOpen,
  breakdownGroup,
  onClose,
  onConfirm,
}: {
  isOpen: boolean;
  breakdownGroup: BreakdownGroupDescriptor;
  onClose: () => void;
  onConfirm: () => void;
}) => {
  return (
    <Modal
      size="xl"
      isOpen={isOpen}
      onClose={onClose}
      titleContent={
        <h3
          className={clsx(
            "heading mx-0 mb-0 mt-0 font-bold text-[1.5rem] max-w-[500px]",
            "leading-8",
          )}
        >
          Switch “{breakdownGroup.name}” to the advanced editor? This action
          cannot be undone.
        </h3>
      }
    >
      <div className="flex items-center justify-end gap-2">
        <TertiaryButton className="ml-2 font-bold" onClick={onClose}>
          CANCEL
        </TertiaryButton>
        <PrimaryButton
          className={clsx("font-bold flex items-center gap-2")}
          onClick={onConfirm}
        >
          YES, CONTINUE
        </PrimaryButton>
      </div>
    </Modal>
  );
};
